//DBTables
import { Button } from "react-bootstrap";
import { DTOModule } from "../../types/building";
import TextEditor from "../Global/Editors/TextEditor";
import { UseFormReturn } from "react-hook-form";
import NumberEditor from "../Global/Editors/NumberEditor";
import { IModuleVattenburetSekundärsystemConfig, IModuleVentilationFTXochFT, IModuleVärmeElConfig } from "../../types/ModuleDatas";
import { getValueByString, nameof } from "../Global/Utils";
import { useState } from "react";
import { DBModuleType, ModuleStatuses, ModuleTypeFamily, ModuleTypeId } from "../../types/DBTables";
import ToolTipBox from "../Global/Editors/ToolTipBox";
import { table } from "console";
import SelectEditor from "../Global/Editors/SelectEditor";
import { MapTooltip } from "../../types/globalData";
import { useGlobalData } from "../GlobalDataProvider";
import { getValue } from "@testing-library/user-event/dist/utils";

export enum WizardModuleTableStyles {
  Normal = 1,
  HeatSecondary = 2,
  Ventilation = 3,
}

interface IProps {
  modules: DTOModule[];
  moduleTypes: DBModuleType[];
  tableStyle: WizardModuleTableStyles;
  formHook: UseFormReturn;
  staticModules?: DTOModule[];
  onRemoveModule: (mId: Number) => void;
  onAddModule: (mt: ModuleTypeId) => void;
}

const WizardModuleTable = ({ modules, moduleTypes, tableStyle, formHook, staticModules, onRemoveModule, onAddModule }: IProps) => {
  const [buttonConfirmationStatus, setButtonConfirmationStatus] = useState<Boolean[]>(Array.from(modules, () => false));

  const globalData = useGlobalData();

  const onRemoveModuleClick = (index: number, module: DTOModule) => {
    if (module.status === ModuleStatuses.Configured && !buttonConfirmationStatus[index]) {
      let arr = buttonConfirmationStatus.slice();
      arr[index] = true;
      setButtonConfirmationStatus(arr);
    } else {
      onRemoveModule(module.id);
      let arr = buttonConfirmationStatus.slice();
      arr.splice(index, 1);
      setButtonConfirmationStatus(arr);
    }
  };

  const onCancelRemoveModule = (index: number) => {
    let arr = buttonConfirmationStatus.slice();
    arr[index] = false;
    setButtonConfirmationStatus(arr);
  };

  const showAddButton =
    modules.find((m) => m.moduleTypeId === ModuleTypeId.KylaSaknas || m.moduleTypeId === ModuleTypeId.VarmePrimarSaknas || m.moduleTypeId === ModuleTypeId.VarmeSekundarSaknas) ===
    undefined;

  const heatSecondaryModuleTypes = globalData.moduleTypes.filter((mt) => mt.family === ModuleTypeFamily.VärmeSekundar);
  const heatElModuleTypes = globalData.moduleTypes.filter((mt) => mt.family === ModuleTypeFamily.VärmeEl);
  const heatSecondaryAllTypes = heatSecondaryModuleTypes.concat(heatElModuleTypes);
  const heatSecondaryModules = modules.filter((m) => heatSecondaryAllTypes.find((mt) => mt.id === m.moduleTypeId));

  const formValues = formHook.getValues();
  const systemandelTotal = heatSecondaryModules.reduce((acc, m) => {
    const data = JSON.parse(m.data) as IModuleVärmeElConfig;
    const modData = formValues[m.id];
    const andel = modData["data"]["värmeSystemandel"] as number;

    if (isNaN(andel)) return acc;

    if (andel === undefined) {
      return acc;
    }

    return acc + andel;
  }, 0);

  formHook.watch();

  return (
    <>
      <table className="m-0 table table-bordered">
        <thead>
          <tr>
            <th style={{ width: 300 }}>Namn</th>
            {tableStyle === WizardModuleTableStyles.HeatSecondary ? (
              <>
                <th style={{ width: 100 }}>Systemandel(%)</th>
                <th style={{ width: 300 }}>Betjäningsområde</th>
              </>
            ) : tableStyle === WizardModuleTableStyles.Ventilation ? (
              <>
                <th style={{ width: 200 }}>Betjänar luftburen värme</th>
              </>
            ) : (
              <></>
            )}
            <th>Typ</th>
            <th style={{ width: 40, textAlign: "center" }}></th>
          </tr>
        </thead>
        <tbody>
          {staticModules?.map((m, index) => (
            <tr className={"table-secondary table-bordered align-middle "} key={m.id}>
              <td>{m.name}</td>
              <td>{"" + moduleTypes.find((mt) => mt.id === m.moduleTypeId)?.displayName}</td>
              <td></td>
            </tr>
          ))}
          {modules.map((m, index) => (
            <tr className={(m.status === ModuleStatuses.Configured ? "table-secondary table-bordered" : "") + " align-middle "} key={m.id}>
              {buttonConfirmationStatus[index] === true ? (
                <>
                  <td colSpan={tableStyle === WizardModuleTableStyles.HeatSecondary ? 5 : 3}>
                    <div className="align-items-center d-grid gap-2 d-md-flex justify-content-md-end">
                      Denna modul är konfigurerad! Är du säker på att du vill ta bort den?
                      <button type="button" className={"btn btn-danger "} onClick={() => onRemoveModuleClick(index, m)}>
                        Ta bort
                      </button>
                      <button type="button" className={"btn btn-secondary "} onClick={() => onCancelRemoveModule(index)}>
                        Avbryt
                      </button>
                    </div>
                  </td>
                </>
              ) : (
                <>
                  <td className="">
                    <TextEditor
                      label=""
                      fieldName={m.id + ".name"}
                      formHook={formHook}
                      options={{
                        validate: {
                          minLength: (value: any) => (value.length < 1 ? "Måste ha ett unikt namn" : undefined),
                        },
                      }}
                    />
                  </td>
                  {tableStyle === WizardModuleTableStyles.HeatSecondary ? (
                    <>
                      {m.moduleTypeId === ModuleTypeId.VarmeSekundarSaknas ? (
                        <>
                          <td className="">
                            <NumberEditor label="" fieldName="" formHook={formHook} isDisabled={true} />
                          </td>
                          <td className="">
                            <TextEditor label="" fieldName="" formHook={formHook} isDisabled={true} />
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="">
                            <NumberEditor
                              label=""
                              fieldName={m.id + ".data." + nameof<IModuleVärmeElConfig>("värmeSystemandel")}
                              formHook={formHook}
                              max={100}
                              min={0}
                              options={{
                                validate: {
                                  required: (v) => {
                                    return !v ? "Ange systemandel" : undefined;
                                  },
                                },
                              }}
                            />
                          </td>
                          <td className="">
                            <TextEditor
                              label=""
                              fieldName={m.id + ".data." + nameof<IModuleVärmeElConfig>("betjäningsområde")}
                              formHook={formHook}
                              options={{
                                validate: {
                                  minLength: (value: any) => (value.length < 1 ? "Måste ha ett betjäningsområde" : undefined),
                                },
                              }}
                            />
                          </td>{" "}
                        </>
                      )}
                    </>
                  ) : tableStyle === WizardModuleTableStyles.Ventilation ? (
                    m.moduleTypeId === ModuleTypeId.VentilationFT || m.moduleTypeId === ModuleTypeId.VentilationFTX ? (
                      <td className="">
                        <SelectEditor
                          label=""
                          fieldName={m.id + ".data." + nameof<IModuleVentilationFTXochFT>("ärHuvudsakligtVärmesystem")}
                          formHook={formHook}
                          tooltipId={nameof<MapTooltip>("VentilationFTXoFT_ärHuvudsakligtVärmesystem")}
                          items={["Nej", "Ja"]}
                        ></SelectEditor>
                      </td>
                    ) : (
                      <td className=""></td>
                    )
                  ) : (
                    <></>
                  )}
                  <td className="">{"" + moduleTypes.find((mt) => mt.id === m.moduleTypeId)?.displayName}</td>
                  <td className="" style={{ textAlign: "center" }}>
                    <Button style={{ width: 25, height: 25 }} className="btn btn-danger p-0" onClick={() => onRemoveModuleClick(index, m)}>
                      X
                    </Button>
                  </td>
                </>
              )}
            </tr>
          ))}
          {tableStyle === WizardModuleTableStyles.HeatSecondary ? (
            <tr className="table-secondary table-bordered align-middle ">
              <td className="d-flex justify-content-end">Total systemandel:</td>
              <td>
                <span className="ps-2">{systemandelTotal}%</span>
              </td>
            </tr>
          ) : (
            <></>
          )}
        </tbody>
      </table>
      <div className="pt-2"></div>
      {/* {heatSecondaryModules.length > 0 ? (
        <div className="row pb-2">
          <div className="col-3">
            <div className="ps-3"> Total systemandel:</div>
          </div>
          <div className="col-9">
            <span className="ps-4">{systemandelTotal}%</span>
          </div>
        </div>
      ) : (
        <></>
      )} */}
      {showAddButton && moduleTypes.length > 0 ? (
        <div className="dropdown">
          <Button disabled={false} type="button" className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown">
            Lägg till
          </Button>
          {/* <Button type="button" className="gy-0 dropdown-item" onClick={() => onAddModule(mt.id)}>
            </Button> */}
          <ul className="dropdown-menu">
            {moduleTypes.map((mt) => (
              <li key={mt.id} className="dropdown-item" onClick={() => onAddModule(mt.id)}>
                {mt.displayName}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <Button disabled={true} type="button" className={"btn btn-primary dropdown-toggle"}>
          Lägg till
        </Button>
      )}
    </>
  );
};

export default WizardModuleTable;
